import React from 'react';

class Bulletin extends React.Component {
	render() {
		return(

			<div>
				<div className="navbar-top">
		          <div className="site-brand">
		            <div className="side-nav-panel-left">
			            <a href="/"> 
			              <i className="fa fa-arrow-left" style={{fontSize: '21px',color: '#F0592D', paddingRight: '8px'}}></i>
			            </a>
		            </div>
		          </div>
		          <div className="site-brand">
		            <a href="/"> 
		              <h2><span className="st2">XPRESS</span><span className="st1">Lite</span></h2>
		            </a>
		          </div>
		          
		        </div>
                <div className="pages section">
					<div className="container">
						<div className="assetsdownload">
							<div className="assetsdownload-content">
								
                    <h6 className="heading-top">XpressNews Bulletins</h6>

					<div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      
					  
					  <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/XpressNews_January_23_2025.pdf">

					 
					 <span className="bulletint_type">XpressNews, 23 January, 2025</span>
                        </a>
                      </div>
					  </div>
					  
					  <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      
					  
					  <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/XpressNews_January_22_2025.pdf">

					 
					 <span className="bulletint_type">XpressNews, 22 January, 2025</span>
                        </a>
                      </div>
					  </div>
					  
					  <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      
					  
					  <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/XpressNews_January_21_2025.pdf">

					 
					 <span className="bulletint_type">XpressNews, 21 January, 2025</span>
                        </a>
                      </div>
					  </div>
					  
					  <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      
					  
					  <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/XpressNews_January_20_2025.pdf">

					 
					 <span className="bulletint_type">XpressNews, 20 January, 2025</span>
                        </a>
                      </div>
					  </div>
					  
					  <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      
					  
					  <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/XpressNews_January_17_2025.pdf">

					 
					 <span className="bulletint_type">XpressNews, 17 January, 2025</span>
                        </a>
                      </div>
					  </div>

					  <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      
					  
					  <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/WeekendXpressNews_January_17_2025.pdf">

					 
					 <span className="bulletint_type">Weekend XpressNews, 17 January, 2025</span>
                        </a>
                      </div>
					  </div>

					  <div className="row" style={{ border : '1px solid', borderColor: '#d0cfce', padding: '10px 0'}}>
                      
					  
					  <div className="col" style={{width: '100%'}}>
                        
					  <a class="normallink" target="_blank" href="https://indianoilxpress.com/uploads/XpressNews/XpressNews_January_16_2025.pdf">

					 
					 <span className="bulletint_type">XpressNews, 16 January, 2025</span>
                        </a>
                      </div>
					  </div>
					 
					  </div>
					  
</div>
</div>
</div>
		  
				<div id="fakeLoader"></div>

				<div className="footer" style={{ width:'100%', bottom:'0',}}>
					<div className="container">
					<div className="copyright">
							<span>Copyright © IndianOilXpress</span><br/>
							<a href="https://www.facebook.com/IndianOilCorpLimited" target="_blank"><i class="fab fa-facebook-f"></i></a>
                <a href="https://twitter.com/indianOilcl" target="_blank"><i class="fab fa-twitter"></i></a>
                <a href="https://www.youtube.com/channel/UC5ho18VZHwEFSahW0Q_o-6g/feed" target="_blank"><i class="fab fa-youtube"></i></a>
				<a href="https://www.instagram.com/indianoilcorp" target="_blank"><i class="fab fa-instagram"></i></a>
				<a href="https://www.linkedin.com/company/indian-oil-corp-limited" target="_blank"><i class="fab fa-linkedin-in"></i></a>
				
						</div>
					</div>
				</div>
</div>
		

		)
	}
}

export default Bulletin;


// WEBPACK FOOTER //
// ./src/bulletin.js